/**
 * -----------------------------------------------------------------------------
 * Popup - Create New Group
 * -----------------------------------------------------------------------------
 * This popup is used for creating a new group in the organization.
 */
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { setModalsData, TModalsState } from "../../../api/store/commonSlice";
import FTModal from "../../../components/common/FTModal";
import GroupEditFormFields from "../../admin-details/group/groupEditFormFields";
import React, { useRef } from "react";
import { serializeErrorKeyValues } from "../../../api/network/errorCodes";
import { toast } from "react-toastify";
import { ACL_NAMES, useACL } from "../../../hooks/acl";
import { ROLE_ACCESS_LEVELS } from "../../admin-details/role/constants";

const ModalEditGroup = () => {
  const { t: tMain } = useTranslation();
  const { t } = useTranslation('translation', { keyPrefix: 'admins.groups.edit_group' });
  const modalsState = useSelector((state: { commonReducer: { modals: TModalsState } }) => state.commonReducer.modals);
  const dispatch = useDispatch();

  const { getUserACLAccessLevel } = useACL();
  const userHasWriteAccess = getUserACLAccessLevel(ACL_NAMES.ACL_ADMIN_GROUP) >= ROLE_ACCESS_LEVELS.WRITE;

  // flag to idenfiy if group is coming from create new group popup
  const isNewEntity = useRef<boolean>(false);

  // flag to enable edit mode
  const [_, setUserCanEdit] = React.useState<boolean>(true);

  // show inactive vehicles mechainism
  const [showInactiveVehicles, setShowInactiveVehicles] = React.useState(false);
  // show inactive users mechanism
  const [showInactiveUsers, setShowInactiveUsers] = React.useState(false);

  const hideModal = () => {
    setShowInactiveVehicles(false);
    setShowInactiveUsers(false);
    dispatch(setModalsData({ ...modalsState, editGroupId: "", editGroupNewMode: false, showEditGroup: false }));
  };

  return (
    <FTModal
      visible={modalsState.showEditGroup}
      heading={t(
        userHasWriteAccess
          ? (modalsState.editGroupNewMode ? "heading_new" : "heading")
          : "heading_readonly"
      )}
      containerStyle={`max-w-[calc(100vw-4rem)] ${userHasWriteAccess ? 'w-[1170px]' : 'w-[536px]'}`}
      onHide={hideModal}
    >
      <GroupEditFormFields
        groupId={modalsState.editGroupId}
        loadingState={false}
        isNewEntity={isNewEntity}
        onUpdateError={(error) => {
          const errors = !!error?.data ? serializeErrorKeyValues(error?.data) : [t('toast.updation_failed')];
          toast.error(errors?.join(' '));
        }}
        onUpdateSuccess={() => {
          toast.success(t("toast.update_success"));
          hideModal();
        }}
        onCancel={hideModal}
        setShowInactiveVehicles={setShowInactiveVehicles}
        setShowInactiveUsers={setShowInactiveUsers}
        setUserCanEdit={setUserCanEdit}
        showInactiveVehicles={showInactiveVehicles}
        showInactiveUsers={showInactiveUsers}
        userCanEdit={true}
        viewOnlyMode={!userHasWriteAccess}
        renderedOnModal={true}
      />
    </FTModal>
  )
};
export default ModalEditGroup;